import { Injectable } from "@angular/core";
import { Course } from "../Models/course.model";
import { Observable } from "rxjs/Observable";
import {map} from 'rxjs/operators';
import { ApiService } from "./api.service";

@Injectable()
export class CourseService{
    private _courses: Course[];

    constructor(
        private _apiService: ApiService,
    ){}

    getAllCourses(): Observable<Course[]>{
        return this._apiService.get(`/course/allCourses`)
                .pipe(map((data) => data.courses));
    }

    getCourseDetails(id: number): Observable<Course>{
        return this._apiService.get(`/course/${id}`)
                .pipe(map((data) => data.course));
    }

    getAddedCourses(ids: number[]): Observable<any>{
        return this._apiService.post(`/course/getCourses`, ids)
            .pipe(map((data) => data.courses)); 
    }
}


// WEBPACK FOOTER //
// ./src/app/Services/course.service.ts